import { render, staticRenderFns } from "./IconSvgNotifications.vue?vue&type=template&id=2e2ba94c&scoped=true&"
import script from "./IconSvgNotifications.vue?vue&type=script&lang=js&"
export * from "./IconSvgNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ba94c",
  null
  
)

export default component.exports